import { Controller } from "@hotwired/stimulus"

// Contact avatars render an external CDN photo (LinkedIn/Unipile) until a
// background job caches the bytes behind /avatars/:id. Those CDN URLs expire,
// so the raw <img> often 404s on first load and only appears after a reload.
// This swaps a failed photo for the initials placeholder so a broken-image
// glyph never shows — no reload needed.
export default class extends Controller {
    static targets = ["img", "fallback"]

    connect() {
        // The error event may have already fired before Stimulus connected
        // (cached 404s resolve instantly); detect a completed-but-empty image.
        if (this.hasImgTarget && this.imgTarget.complete && this.imgTarget.naturalWidth === 0) {
            this.failed()
        }
    }

    failed() {
        if (this.hasImgTarget) this.imgTarget.remove()
        if (this.hasFallbackTarget) this.fallbackTarget.hidden = false
    }
}
